import { cartFields } from '@pylot-data/core-queries/cart'

export const CART_QUERY = /* GraphQL */ `
    query getCart($cartId: String!, $isSignedIn: Boolean = false) {
        cart(cart_id: $cartId) {
            ${cartFields}
        }
    }
`
export const CUSTOMER_CART_QUERY = /* GraphQL */ `
    query getCustomerCart($isSignedIn: Boolean!) {
        cart: customerCart {
            ${cartFields}
        }
    }
`
export const FREE_SHIPPING_RULE = /* GraphQL */ `
    query {
        getShippingAmount {
            name
            is_active
            subTotalAmount
            excludeCategorys
        }
    }
`
